<template>
	<div>
		<filter-panel labelWidth="100px" :data="groups" @search="filterChange"></filter-panel>

		<data-list
			v-loading="loading"
			:table-style="{ name: 'webclient' }"
			:data="data"
			:columns="column"
			:btnList="btnList"
			:page="page"
			@sort-change="sortChange"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<el-drawer
			ref="drawer"
			title="广告系列"
			size="50%"
			v-loading="drawerLoading"
			:visible.sync="drawer"
			custom-class="custom_class"
			:show-close="false"
			:with-header="false">
			<div class="close_drawer"><span @click="$refs.drawer.closeDrawer()">收起</span></div>
			<div class="info_box">
				<div class="info">
					<div class="info_tit_test">
						<span class="info_tit">广告系列：{{drawerDetail.name || '-'}}</span>
						<span class="edit" @click="edit(drawerDetail)">编辑</span>
					</div>
					<div class="info_list">
						<span>状态：{{getStatus || '-'}}</span>
						<span>类型：{{drawerDetail.advertisingChannelTypeDesc || '-'}}</span>
						<span>日预算：￥{{drawerDetail.budget || '-'}}/天</span>
					</div>
				</div>
				<div class="info">
					<div class="info_tit">
						广告系列设置
					</div>
					<div class="setting">
						<div class="set_left">
							<span class="set_lable">出价策略类型</span>
							<span>{{drawerDetail.biddingStrategyTypeDesc || '-'}}</span>
						</div>
						<div class="set_right">
							<span class="set_lable">广告系列设备出价调整</span>
							<span>{{drawerDetail.equipment || '-'}}</span>
						</div>
					</div>
					<div class="setting">
						<div class="set_left">
							<span class="set_lable">语言定位</span>
							<span>{{drawerDetail.languages || '-'}}</span>
						</div>
						<div class="set_right">
							<span class="set_lable">投放网络</span>
							<span>{{drawerDetail.launchNetwork || '-'}}</span>
						</div>
					</div>
					<div class="setting">
						<div class="set_left">
							<span class="set_lable">投放国家/地区</span>
							<span>{{drawerDetail.locations || '-'}}</span>
						</div>
						<div class="set_right">
							<span class="set_lable">排除国家/地区</span>
							<span>{{drawerDetail.excludeLocations || '-'}}</span>
						</div>
					</div>
					<div class="setting">
						<div class="set_left">
							<span class="set_lable">投放起止日期</span>
							<span>{{drawerDetail.startDate || '-'}} ~ {{ drawerDetail.endDate || '-' }}</span>
						</div>
						<div class="set_right">
							<span class="set_lable">投放时间段</span>
							<span v-for="(val, ind) in drawerDetail.adScheduleVoList" :key="ind"> {{ val || '-' }} </span>
						</div>
					</div>
				</div>
			</div>
		</el-drawer>
		<customColumnModal
			:visible.sync="visible"
			nameKey="customsName"
			:list="lists"
			:customChecked="customChecked"
			@getColumn="getColumn">
		</customColumnModal>
	</div>
</template>
<script>
import { adSeriesStatus, accountsStatus } from '@/common/dictionary.js';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import customColumnModal from '@/components/iglobalwin/formComponents/customColumn/custom-column-modal.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
// import customerMinxins from '@/mixins/customer';
const list = listPageCreate({
	searchConfig: {
		api: api.googleAds.getCampaignList,
		method: 'POST',
	},
	getQuery(data,val) {
		return _.assign({}, data, {
			types: ['SEARCH'], // 暂时固定类型，后面调整
			startDate: val.time ? val.time[0] : '',
			endDate: val.time ? val.time[1] : '',
			status: JSON.parse(localStorage.getItem('adSeriesStatus')),
		});
	},
});

export default {
	props: {
		time: {
			type: Array,
			default: function () {
				return [];
			},
		}
	},
	mixins: [list],
	data() {
		return {
			column: [],
			groups: {},
			btnList: [],
			dialogVisible: false,
			drawer: false,
			drawerLoading: false,
			drawerDetail: {},
			visible: false,
			lists: [],
			customChecked: [],
		};
	},

	computed: {
		getStatus() {
			return accountsStatus[this.drawerDetail.status]
		},
	},

	watch: {
    time: {
      handler () {
				this.query();
      },
      // immediate: true,
			deep: true,
    },
  },

	methods: {
		filterChange(val) {
			localStorage.setItem('adSeriesStatus',JSON.stringify(val.status));
			this.query();
		},
		requestData() {
			this.setGroups();
		},
		setGroups() {
			let that = this;
			this.groups = {
				others: [
					{
            tagName: 'sky-select',
            placeholder: '请选择广告系列状态',
            label: '广告系列状态',
            // inputTitle: '广告系列状态',
            tagFormatStyle: true,
            // 'collapse-tags': true,
            prop: 'status',
            multiple: true,
            value: ['ENABLED', 'PAUSED'] ,
            options: adSeriesStatus,
          },
				],
			};

			this.btnList = [
				{
					name: '新建广告系列',
					position: 'left',
					attribute: {
						type: 'primary',
						size: 'small',
					},
					btnClick: this.addSeries,
				},
        {
					name: '自定义列',
					position: 'right',
					attribute: {
						// type: 'primary',
						size: 'small',
					},
					btnClick: this.getColumn,
				},
        // {
				// 	name: '导出数据',
				// 	position: 'right',
				// 	attribute: {
				// 		type: 'primary',
				// 		size: 'small',
				// 	},
				// 	btnClick: this.exportData,
				// },
			];
			this.column = [
				{
          label: '状态',
          type: 'switchBtn',
          bind: 'status',
					fixed: "left",
          activeValue: 'ENABLED',
          inactiveValue: 'PAUSED',
          toggle(val, row) {
						that.changeStatus(val,row);
          },
        },
				{
					label: '广告系列名称',
					type: 'linkClick',
					bind: 'name',
					fixed: "left",
					minWidth: 160,
					showOverflowTooltip: true,
					click(val) {
						that.$router.push({
							name: 'accountManagement',
							query: {
								adSeriesId: val.row.id,
								adSeriesName: val.row.name,
							},
						});
					}
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					fixed: "left",
					minWidth: 140,
					bind() {
						let arr = [
							{
								text: '详情',
								trigger: row => {
									that.openDrawer(row);
								},
							},
              {
								text: '编辑',
								trigger: row => {
									that.edit(row);
								},
								showButton(row) {
									return row.status !== 'REMOVED';
								},
							},
              {
								text: '移除',
								trigger: row => {
									that.remove(row);
								},
								showButton(row) {
									return row.status !== 'REMOVED';
								},
							},
						];

						return arr;
					},
				},
				{
					label: '日预算(￥)',
					bind: 'budget',
					minWidth: 120,
					sort: 'budget',
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '消耗(￥)',
					bind: 'cost',
					sort: 'cost',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '展示次数',
					bind: 'impressions',
					sort: 'impressions',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '点击次数',
					bind: 'clicks',
					sort: 'clicks',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
				{
					label: '转化次数',
					bind: 'conversions',
					sort: 'conversions',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
        {
					label: '点击率',
					bind: 'ctr',
					type: 'defaultTextUnitCustom',
					sort: 'ctr',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
					click(val) {
						return ''+val.row.ctr+'%'
					}
				},
        {
					label: '点击均价(￥)',
					bind: 'averageCpc',
					sort: 'averageCpc',
					minWidth: 120,
					options: [
						{
							label: '由低到高',
							value: 'ASC',
						},
						{
							label: '由高到低',
							value: 'DESC',
						},
					],
				},
			];
		},
    async changeStatus(val, row) {
      try {
        let res = await googleads.getCampaignStatus({ id: row.id, status: val });
        if (res.status >= 200 && res.status < 400) {
          this.$message.success('更改成功');
        }
      } catch (e) {
        this.$message.info('更改成功');
      }
      this.query();
    },
		// 查看详情
		async openDrawer(row) {
			try {
				this.drawer = true;
				this.drawerLoading = true;
				this.drawerDetail = {adScheduleVoList:null};
				let res = await googleads.getCampaignDetail(row.id);
				this.drawerDetail = {...res.data, ...row};
				this.drawerLoading = false;
			} catch (e) {
				this.drawerLoading = false;
			}
		},
		// 移除状态修改
		remove(row) {
			this.$confirm('确定要移除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async() => {
				let res = await googleads.getCampaignRemove({ id: row.id, status: 'REMOVED' });
				if (res.status >= 200 && res.status < 400) {
					this.$message.success('移除成功');
					this.query();
				}else {
					this.$message.info('移除失败');
				}
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消移除'
				});          
			});
		},
		// exportData() {
		// 	console.log('导出数据')
		// },
		// 编辑
		edit(row) {
			this.$refs.drawer.closeDrawer(); // 关闭详情抽屉
			this.$router.push({
				name: 'addAdSeries',
				query: {
					adSeriesId: row.id,
					adSeriesName: row.name,
					resourceName: row.resourceName,
					edit: row.id
				},
			});
		},
		// 获取自定义列表数据
		async getColumn(val) {
			if(Object.prototype.toString.call(val) === '[object Array]') {
				this.visible = false;
				let arr = [];
				arr = val.map(item => {
					return {
						...item,
						type: 1
					}
				})
				await googleads.insertCustomfieldList(arr);
				// 所有列表数据
				this.getColumnLists()
			}else {
				this.visible = true;
				let res = await googleads.getCustomfieldList(1);
				// 所有列表数据
				this.lists = res.data;
			}
		},
		// 获取列表数据
		async getColumnLists() {
			// 当前用户列表自定义字段数据
			let res = await googleads.getCustomfieldUserList(1);
			this.column = this.dataConversion(res.data);
			// 所有选中自定义列表数据
			this.customChecked = res.data;
		},
		// 数据转换
		dataConversion(data) {
			let that = this, newArr = [];
			// 带排序功能列表字段
			let sortCode = ['budget','cost','impressions','clicks','conversions','ctr','averageCpc'];
			// 单位 元
			let unitY = ['budget','cost','averageCpc'];
			// 单位 百分比 %
			let unitPercent = ['ctr','conversionsFromInteractionsRate'];
			data.forEach(item => {
				let lab = '';
				if((unitY.indexOf(item.columnCode.split('.')[1]) != -1 || unitY.indexOf(item.columnCode.split('.')[0]) != -1)) {
					// 加上单位 元
					lab = item.columnName + ' (￥)';
				}else if((unitPercent.indexOf(item.columnCode.split('.')[1]) != -1 || unitPercent.indexOf(item.columnCode.split('.')[0]) != -1)) {
					// 加上单位 百分比 %
					lab = item.columnName + ' (%)';
				}else {
					lab = item.columnName;
				}
				let obj = {
						label: lab,
						bind: item.columnCode.split('.')[1] || item.columnCode.split('.')[0],
						// fixed: item.columnCode.split('.')[1] == 'name' ? 'left' : '',
						minWidth: 120,
						showOverflowTooltip: true,
					};
				if(item.columnCode.split('.')[1] == 'name' || item.columnCode.split('.')[0] == 'name') {
					// 当字段为广告系列名称时，修改type类型，增加 操作 字段列
					newArr.push(
					{
						...obj,
						minWidth: 160,
						type: 'linkClick',
						fixed: "left",
						click(val) {
							that.$router.push({
								name: 'accountManagement',
								query: {
									adSeriesId: val.row.id,
									adSeriesName: val.row.name,
								},
							});
						}
					},
					{
						label: '操作',
						type: 'btnClick',
						align: 'left',
						style: 'text',
						fixed: "left",
						minWidth: 140,
						bind() {
							return [
								{
									text: '详情',
									trigger: row => {
										that.openDrawer(row);
									},
								},
								{
									text: '编辑',
									trigger: row => {
										that.edit(row);
									},
									showButton(row) {
										return row.status !== 'REMOVED';
									},
								},
								{
									text: '移除',
									trigger: row => {
										that.remove(row);
									},
									showButton(row) {
										return row.status !== 'REMOVED';
									},
								},
							];
						},
					});
				} else if(unitPercent.indexOf(item.columnCode.split('.')[1]) != -1 || unitPercent.indexOf(item.columnCode.split('.')[0]) != -1) {
					// 当字段为百分号单位时，增加百分号
					newArr.push({
						...obj,
						type: 'defaultTextUnitCustom',
						click(val) {
							let res =item.columnCode.split('.')[1] || item.columnCode.split('.')[0];
							if(val.row[res] != undefined) {
								return val.row[res].toFixed(2)+'%';
							}else {
								return '-'
							}
						}
					})

				}else if(sortCode.indexOf(item.columnCode.split('.')[1]) != -1 || sortCode.indexOf(item.columnCode.split('.')[0]) != -1) {
					// 当字段为排序列表字段，增加排序配置
					newArr.push({
						...obj,
						// sort: item.columnCode.split('.')[1] || item.columnCode.split('.')[0],
						sort: item.googleApiField,
						options: [
							{
								label: '由低到高',
								value: 'ASC',
							},
							{
								label: '由高到低',
								value: 'DESC',
							},
						],
					})
				}else {
					// 其他普通字段直接添加
					newArr.push(obj);
				}
			});
			// 最后在列表首部增加状态字段
			newArr.unshift(
				{
          label: '状态',
          type: 'switchBtn',
          bind: 'status',
					fixed: "left",
          activeValue: 'ENABLED',
          inactiveValue: 'PAUSED',
          toggle(val, row) {
						that.changeStatus(val,row);
          },
        }
			);
			return newArr;
		},
		// 新建广告系列
		addSeries() {
			this.$router.push({
				name: 'addAdSeries',
			});
		},
	},
	mounted() {
		this.requestData();
		if(!JSON.parse(localStorage.getItem('adSeriesStatus'))) {
			localStorage.setItem('adSeriesStatus',JSON.stringify(['ENABLED','PAUSED'])); // 广告系列默认搜索条件
		}
		this.setGroups();
		if(this.$route.path.includes('accountManagement')) {
			this.groups.others[0].value = JSON.parse(localStorage.getItem('adSeriesStatus')) || ['ENABLED','PAUSED'];
		}
		this.getColumnLists();
		this.query();
	},
	components: { filterPanel, customColumnModal },
};
</script>
<style lang="scss">
.custom_class {
	overflow-y: auto;
	background-color: #F6F8FC;
	.el-drawer__header {
		display: none;
	}
	.close_drawer {
		line-height: 40px;
		padding-left: 20px;
		color: #3DA1FF ;
		background-color: #FFFFFF;
		&>span {
			cursor: pointer;
		}
	}
	.info_box {
		padding: 20px;
		.info {
			padding: 30px;
			margin-bottom: 10px;
			line-height: 40px;
			border-radius: 6px;
			background: #FFFFFF ;
			.info_tit_test {
				display: flex;
				justify-content: space-between;
				.edit {
					color: #3DA1FF;
					cursor: pointer;
				}
			}
			.info_list{
				&>span {
					padding-right: 60px;
				}
				// display: flex;
				// justify-content: space-between;
			}
			.info_tit {
				font-size: 16px;
				color: #333333;
				font-weight: 600;
				word-break: break-all;
			}
			.setting {
				display: flex;
				padding-top: 10px;
				.set_left {
					flex: 1;
					display: flex;
					flex-direction: column;
					line-height: 25px;
				}
				.set_right {
					flex: 1;
					display: flex;
					flex-direction: column;
					line-height: 25px;
				}
				.set_lable {
					color: #999999;
				}
			}
		}
	}
}
</style>
